import { render, staticRenderFns } from "./Subtype.vue?vue&type=template&id=49b26e97&scoped=true&"
import script from "./Subtype.vue?vue&type=script&lang=js&"
export * from "./Subtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b26e97",
  null
  
)

export default component.exports